// @ts-strict-ignore
import React from "react";
import { Heading } from "app/_components/components/Text/Heading";
import { Body } from "app/_components/components/Text/Body";
import NextLink from "components/parts/NextLink";
import { ContentfulResponsiveImage } from "components/common/image/ContentfulResponsiveImage";
import type { CoinResourcesProps, CtaProps } from "types/prices";

const CoinResources = (props: CoinResourcesProps) => {
  const { cta, title } = props?.coinResources || {};

  const renderIcon = ({ data }: { data: CtaProps }) => {
    if (!data?.image?.url) return null;
    return (
      <ContentfulResponsiveImage
        priority
        alt={data?.image?.altText}
        sizes={[
          {
            media: "(max-width: 250px)",
            src: data?.image?.url,
            height: data?.image?.height || 24,
            width: data?.image?.width || 24
          }
        ]}
      />
    );
  };

  return (
    <div className="mb-[46px] w-full">
      {title && (
        <Heading
          size="md"
          className="mb-8 !leading-[28px] !font-medium !tracking-[-0.5px]"
        >
          {title}
        </Heading>
      )}
      {cta &&
        cta.length > 0 &&
        cta.map((data: CtaProps, index: number) => {
          return (
            <div
              key={index}
              className="flex w-full items-center justify-between border-b border-gray-100 py-[14px]"
            >
              <Body size="sm" className="m-0">
                {data?.name}
              </Body>
              {data?.link ? (
                <NextLink
                  href={data?.link || "#"}
                  raw={true}
                  id={`button-${index}`}
                >
                  {renderIcon({ data })}
                </NextLink>
              ) : (
                renderIcon({ data })
              )}
            </div>
          );
        })}
    </div>
  );
};

export default CoinResources;
